import React, { useState, useContext, useEffect } from 'react';
import { useRouter } from 'next/router';
import {
  Button,
  MenuItem,
  Menu,
  FormControlLabel,
  Radio,
} from '@material-ui/core';
import { GoTriangleDown, GoTriangleUp } from 'react-icons/go';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import BrFlag from '../../../public/images/portuguese.svg';
import USFlag from '../../../public/images/english.svg';
import EsFlag from '../../../public/images/espanha.svg';
import useStyles from './styles';
import useTranslation from 'hooks/useTranslation';
import Image from 'next/image';
import parse from 'html-react-parser';
import theme from 'styles/theme';
import Cookies from 'js-cookie';

const SelectLanguageLP: React.FC = () => {
  const { locale } = useRouter();
  const { t } = useTranslation();
  const router = useRouter();
  const classes = useStyles();
  const languagesOption = ['pt', 'en', 'es'];
  /* eslint-disable-next-line */
  const [selectedIndexMenu, setSelectedIndexMenu] = useState(1);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClickMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    Cookies.set('instasorteioLanguage', String(router.locale));
  }, [router.locale]);

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLElement>,
    index: number,
    option: string,
  ) => {
    let lang: 'pt' | 'en' | 'es' = 'pt';
    if (option === 'en') {
      lang = 'en';
    }
    if (option === 'pt') {
      lang = 'pt';
    }
    if (option === 'es') {
      lang = 'es';
    }
    // alterLanguage(lang);
    // localStorage.set("@instasorteio:language", lang);
    router.push(router.pathname, router.pathname, { locale: lang });
    setSelectedIndexMenu(index);
    setAnchorEl(null);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.box}>
      <Button
        onClick={handleClickMenu}
        endIcon={anchorEl ? <GoTriangleUp /> : <GoTriangleDown />}
        style={{ width: 50 }}
      >
        {t('flag') === 'USFlag' && (
          <Image
            src={parse(t('flag')) === 'USFlag' && USFlag}
            alt="lang"
            width={36}
            height={26}
          />
        )}
        {t('flag') === 'BrFlag' && (
          <Image
            src={parse(t('flag')) === 'BrFlag' && BrFlag}
            alt="lang"
            width={36}
            height={26}
          />
        )}
        {t('flag') === 'EsFlag' && (
          <Image
            src={parse(t('flag')) === 'EsFlag' && EsFlag}
            alt="lang"
            width={36}
            height={26}
          />
        )}
        {/* <Image
          src={parse(t("flag")) === "USFlag" ? USFlag : BrFlag}
          alt="lang"
          width={36}
          height={26}
        /> */}
      </Button>

      <Menu
        onClose={handleCloseMenu}
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        open={Boolean(anchorEl)}
        className={classes.menu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        {languagesOption.map((option, index) => (
          <MenuItem
            key={option}
            selected={locale === option}
            onClick={event => handleMenuItemClick(event, index, option)}
            className={classes.menuItem}
            style={{ backgroundColor: 'transparent' }}
          >
            {option === 'pt' && (
              <div style={{ alignItems: 'center', display: 'flex' }}>
                <Image src={BrFlag} alt="portuguese" />
                <input
                  type="radio"
                  checked={locale === 'pt'}
                  style={{ marginLeft: 8 }}
                />
              </div>
            )}
            {option === 'en' && (
              <div style={{ alignItems: 'center', display: 'flex' }}>
                <Image src={USFlag} alt="english" />

                <input
                  type="radio"
                  checked={locale === 'en'}
                  style={{ marginLeft: 8 }}
                />
              </div>
            )}
            {option === 'es' && (
              <div style={{ alignItems: 'center', display: 'flex' }}>
                <Image src={EsFlag} alt="espanhol" />

                <input
                  type="radio"
                  checked={locale === 'es'}
                  style={{ marginLeft: 8 }}
                />
              </div>
            )}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default SelectLanguageLP;
